import {
  GetAllAgenciesResponseBodyType,
  GetFullAgencyByIdResponseBodyType,
} from "@intelligems/ig-types";
import {
  PutAgencyRequestBodyType,
  PutAgencyRequestPathParamType,
  PutAgencyResponseBodyType,
} from "@intelligems/ig-types/functions/agencies/put-agency";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const putAgency = async (
  data: ApiRequest<PutAgencyRequestBodyType, PutAgencyRequestPathParamType>
) => {
  const resp = await api.put<PutAgencyResponseBodyType>(
    `/v2/admin/agencies${data.pathParams.id ? `/${data.pathParams.id}` : ""}`,
    { ...data.body }
  );
  return resp.data;
};
export const usePutAgency = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PutAgencyResponseBodyType,
    Error,
    ApiRequest<PutAgencyRequestBodyType, PutAgencyRequestPathParamType>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<PutAgencyRequestBodyType, PutAgencyRequestPathParamType>
    ) => putAgency(data),
    onSuccess: (data) => {
      queryClient.setQueryData(
        adminKeys.agencies,
        (oldData: GetAllAgenciesResponseBodyType) => {
          if (!oldData) return oldData;
          const agencyIndex = oldData.agencies.findIndex(
            (agency) => agency.id === data.agency.id
          );
          if (agencyIndex === -1) {
            return {
              ...oldData,
              agencies: [...oldData.agencies, data.agency],
            };
          }
          oldData.agencies[agencyIndex] = data.agency;
          return oldData;
        }
      );
    },
  });
};
